/* Minimal, CSP-safe initializer for Flex — Text & Gallery sections */
(function () {
  function init(root) {
    if (!root || root.dataset.awInited === "1") return;
    root.dataset.awInited = "1";

    var slides = Array.prototype.slice.call(
      root.querySelectorAll("#gallery-" + root.dataset.sectionId + " .slide")
    );
    if (!slides.length) return;

    var i = slides.findIndex(function (s) { return s.classList.contains("is-active"); });
    if (i < 0) { i = 0; slides[0].classList.add("is-active"); }

    function show(n) {
      slides[i].classList.remove("is-active");
      i = (n + slides.length) % slides.length;
      slides[i].classList.add("is-active");
    }

    // Click handlers
    var prev = root.querySelector(".nav--prev");
    var next = root.querySelector(".nav--next");
    if (prev) prev.addEventListener("click", function (e) { e.preventDefault(); show(i - 1); });
    if (next) next.addEventListener("click", function (e) { e.preventDefault(); show(i + 1); });

    // Keyboard (when section focused)
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") show(i - 1);
      else if (e.key === "ArrowRight") show(i + 1);
    });

    // Touch swipe
    var startX = null, vp = root.querySelector("#gallery-" + root.dataset.sectionId);
    if (vp) {
      vp.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
      vp.addEventListener("touchend", function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { dx > 0 ? show(i - 1) : show(i + 1); }
        startX = null;
      }, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll(".flex-tg[data-section-id]").forEach(init);
  }

  // Initial load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme Editor: sections re-render
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target && e.target.querySelector(".flex-tg[data-section-id]");
    if (el) init(el);
  });
})();
